import { Modal } from "@gravity-ui/uikit";

import { PromotionContent } from "../PromotionContent";

interface PromotionModalProps {
  open: boolean;
  onClose: () => void;
}

export const PromotionModal = ({ open, onClose }: PromotionModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <PromotionContent isModal={true} onClose={onClose} />
    </Modal>
  );
};
